module.exports = __webpack_public_path__ + "static/media/delete-bin.63ad8640.svg";